import { render, staticRenderFns } from "./SitemapsManager.vue?vue&type=template&id=6dd3e35d&scoped=true"
import script from "./SitemapsManager.vue?vue&type=script&lang=js"
export * from "./SitemapsManager.vue?vue&type=script&lang=js"
import style0 from "./SitemapsManager.vue?vue&type=style&index=0&id=6dd3e35d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3e35d",
  null
  
)

export default component.exports